import { z } from 'zod';

/**
 * Slack integration settings stored as a single doc at `settings/slack`.
 *
 * The API caches the doc in memory for 60s, so admin edits propagate within
 * a minute (or instantly via the `invalidateSlackSettingsCache` helper after
 * a PATCH). When the doc is missing we fall back to the env defaults
 * (`SLACK_DEFAULT_CHANNEL`, `SLACK_BOT_TOKEN`).
 */
export const slackSettingsSchema = z.object({
  channel: z.string().min(1).max(80),
  enabled: z.boolean().default(true),
  updatedAt: z.string().datetime().nullable().default(null),
  updatedBy: z.string().nullable().default(null),
});
export type SlackSettings = z.infer<typeof slackSettingsSchema>;

export const updateSlackSettingsSchema = z.object({
  channel: z.string().trim().min(1).max(80).optional(),
  enabled: z.boolean().optional(),
});
export type UpdateSlackSettingsInput = z.infer<typeof updateSlackSettingsSchema>;

/**
 * Wire response for `GET /settings/slack` — adds `botTokenConfigured` so the
 * admin UI can warn that even an "enabled" channel can't actually post if the
 * bot token env var is missing.
 */
export const slackSettingsResponseSchema = slackSettingsSchema.extend({
  botTokenConfigured: z.boolean(),
});
export type SlackSettingsResponse = z.infer<typeof slackSettingsResponseSchema>;
